/**
 * Demo users — one row per role plus the active "you" user.
 *
 * `getDemoUser(role)` is called by ./beta-mode.js#enterBeta to plant the
 * fake user in localStorage so RBAC/sidebar/topbar all behave correctly.
 */
const PHARMACIE_ID = "beta-pharm-001";

const PROPRIETAIRE = {
  id: "beta-user-proprietaire",
  nom: "Belkacem",
  prenom: "Amine",
  email: "proprietaire@demo.pharmakon.dz",
  role: "PROPRIETAIRE",
  is_active: true,
  pharmacie_id: PHARMACIE_ID,
  created_at: "2024-01-15T09:00:00.000Z",
};

const MANAGER = {
  id: "beta-user-manager",
  nom: "Hadjadj",
  prenom: "Lila",
  email: "manager@demo.pharmakon.dz",
  role: "MANAGER",
  is_active: true,
  pharmacie_id: PHARMACIE_ID,
  created_at: "2024-02-01T09:00:00.000Z",
};

const CAISSIER_1 = {
  id: "beta-user-caissier-1",
  nom: "Mahdi",
  prenom: "Yasmine",
  email: "caissier@demo.pharmakon.dz",
  role: "CAISSIER",
  is_active: true,
  pharmacie_id: PHARMACIE_ID,
  created_at: "2024-02-15T09:00:00.000Z",
};

const CAISSIER_2 = {
  id: "beta-user-caissier-2",
  nom: "Bensaada",
  prenom: "Rachid",
  email: "rachid@demo.pharmakon.dz",
  role: "CAISSIER",
  is_active: true,
  pharmacie_id: PHARMACIE_ID,
  created_at: "2024-03-10T09:00:00.000Z",
};

const ALL = [PROPRIETAIRE, MANAGER, CAISSIER_1, CAISSIER_2];

const PHARMACIE_INLINE = {
  id: PHARMACIE_ID,
  nom: "Pharmacie Démo PHARMAKON",
  logo_url: null,
};

// Demo licence — the BETA tenant has every paid module activated so the
// reviewer can walk the entire SaaS surface. ModuleGate reads this via
// user.licence.modules (or user.modules); see client/src/components/billing/
// ModuleGate.jsx#resolveModules.
const DEMO_LICENCE = {
  id: "beta-licence-001",
  statut: "ACTIVE",
  modules: [
    "CORE",
    "CHIFA",
    "AIDE_DECISION",
    "EFACTURE",
    "MULTI_CAISSE",
    "BACKUP_AUTO",
  ],
};

/** Returns the synthetic logged-in user for the requested BETA role. */
export function getDemoUser(role) {
  const base =
    role === "PROPRIETAIRE"
      ? PROPRIETAIRE
      : role === "MANAGER"
        ? MANAGER
        : CAISSIER_1;
  return {
    ...base,
    pharmacie: PHARMACIE_INLINE,
    is_beta: true,
    beta_role: role,
    // Flatten modules at top level (ModuleGate prefers user.modules) AND
    // keep the nested licence for components that read user.licence.*.
    modules: DEMO_LICENCE.modules,
    licence: DEMO_LICENCE,
  };
}

/** Seed payload — returns every demo user. */
export function buildUsers() {
  return ALL.map((u) => ({ ...u, pharmacie: PHARMACIE_INLINE }));
}
